import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import rootReducer from '../reducers/index';

const persistConfig = {
    key: 'heirs',
    storage,
    whitelist: [ // Survives refresh
        'user',
        'tour'
    ],
    blacklist: [ // Does not survive refresh
        'config',
        'sidebar'
    ],
    throttle: 250,
    transforms: process.env.NODE_ENV === 'production' ? [
        encryptTransform({
            secretKey: process.env.REACT_APP_REDUX_KEY,
            onError: function (error) {
                console.error(error);
            },
        }),
    ] : [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, applyMiddleware(thunk));
let persistor = persistStore(store);

export { store, persistor };